import { getRowKey } from '../../cancellation-followups/subparts/cancellationFollowupChannel';

const isClinicSurvey = (survey) =>
    survey?.assignmentScope !== 'DOCTOR' || !survey?.assignedUserId;

const isDoctorSurveyForRecord = (survey, record) =>
    survey?.assignmentScope === 'DOCTOR' &&
    Boolean(survey?.assignedUserId) &&
    Boolean(record?.doctorUserId) &&
    survey.assignedUserId === record.doctorUserId;

export const getRowSurveyOptions = (record, activeSurveys = []) => {
    if (!activeSurveys.length) {
        return [];
    }

    const clinicSurveys = [];
    const doctorSurveys = [];

    activeSurveys.forEach((survey) => {
        if (isDoctorSurveyForRecord(survey, record)) {
            doctorSurveys.push(survey);
            return;
        }

        if (isClinicSurvey(survey)) {
            clinicSurveys.push(survey);
        }
    });

    return [...clinicSurveys, ...doctorSurveys];
};

export const resolveDefaultSurveyId = (record, activeSurveys = []) => {
    const options = getRowSurveyOptions(record, activeSurveys);
    if (!options.length) {
        return null;
    }

    const clinicSurvey = options.find(isClinicSurvey);
    if (clinicSurvey) {
        return clinicSurvey.id;
    }

    return options[0]?.id ?? null;
};

export const buildDefaultSurveySelections = (records, activeSurveys = []) =>
    records.reduce((acc, record) => {
        acc[getRowKey(record)] = resolveDefaultSurveyId(record, activeSurveys);
        return acc;
    }, {});

export const getRowSurveySelection = (surveySelections, rowKey, record, activeSurveys = []) => {
    const selected = surveySelections[rowKey];
    const options = getRowSurveyOptions(record, activeSurveys);

    if (!options.length) {
        return null;
    }

    if (selected && options.some((survey) => survey.id === selected)) {
        return selected;
    }

    return resolveDefaultSurveyId(record, activeSurveys);
};

export const getSurveyTitle = (surveyId, activeSurveys = []) => {
    const survey = activeSurveys.find((item) => item.id === surveyId);
    return survey?.title || 'Untitled survey';
};

export const hasRowSurveyOptions = (record, activeSurveys = []) =>
    getRowSurveyOptions(record, activeSurveys).length > 0;
